import * as React from 'react';
const SvgWebflow = (props) => (
  <svg viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M68.707 34.354C68.707 15.38 53.327 0 34.354 0S0 15.38 0 34.354c0 18.973 15.38 34.353 34.354 34.353 18.973 0 34.353-15.38 34.353-34.353Z"
      fill="#146EF5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.387 22.187 43.72 48.907H30.881l5.72-11.074h-.256c-4.72 6.126-11.76 10.158-21.792 11.073v-10.92s6.417-.38 10.19-4.346h-10.19V22.187h11.453v9.42l.257-.001 4.68-9.419h8.662v9.36h.257l4.856-9.36h12.67Z"
      fill="#fff"
    />
  </svg>
);
export default SvgWebflow;
